<template>
  <BaseLayout page-default-back-link="/nativeTab/news" :pageTitle="textData.title">
    <ion-content class="certification-uploadDocuments">
      <div class="label p-l-20 p-r-20 p-b-30 p-t-30">请仔细查看下方您的信息是否正确，并上传正确的认证资料确保您的认证成功。</div>
      <div class="card f-1">
        <div
          v-for="(item, index) in keysData"
          class="pc-input-box"
          :class="[
              {'pc-input-is-error' : requiredErrorKey === item.key},
              {'pc-input-is-required' : !form[item.key] && item.isRequired},
              {'m-b-50': keysData.length - 1 == index}
          ]"
          :key="index"
        >
          <input
            v-if="item.type == 'text'"
            class="is-required pc-input"
            :ref="el => nodes[item.key].value = el"
            v-model="form[item.key]"
            @blur="onBlur"
            :placeholder="item.label"
          />
          <input
            v-if="item.type == 'actionSheet'"
            class="is-required pc-input"
            :ref="el => nodes[item.key].value = el"
            :value="listToJson(selects[item.key])[form[item.key]]"
            @blur="onBlur"
            @click="presentActionSheet(item.key)"
            :placeholder="item.label"
          />
          <div class="w-100b h-100b" v-if="item.type == 'date'">
            <input
              class="pc-input"
              :ref="el => nodes[item.key].value = el"
              v-model="form[item.key]"
              @blur="onBlur"
              :placeholder="item.label"
            />
            <ion-datetime
              class="pc-input-date"
              @ionChange="(t) => onDateChange(item.key, t.detail.value)"
              display-format="YYYY MM DDDD"
              min="1950"
              max="2021"
              :value="form[item.key]"
            ></ion-datetime>
          </div>
        </div>
      </div>
      <IDCard
        type="private"
        :idCardBackKey="idCardBackKey"
        :idCardPositiveKey="idCardPositiveKey"
        :idCardUserKey="idCardUserKey"
        :idCardBackUrl="idCardBackUrl"
        :idCardPositiveUrl="idCardPositiveUrl"
        :idCardUserUrl="idCardUserUrl"
        :titleOne="textData.IDCardTitles[0]"
        :titleTow="textData.IDCardTitles[1]"
        @onCaptured="({ key, value }) => onCaptured(key, value)"
      />
      <div class="m-b-100 m-l-75 m-r-75">
        <ion-button expand="block" @click="onSubmit">提交</ion-button>
      </div>
    </ion-content>
  </BaseLayout>
</template>

<script>
import router from '@/router'
import { ref, reactive, onBeforeMount } from 'vue'
import { IDCard } from '@/view/certification/components'
import { useRoute } from 'vue-router'
import { Camera } from '@/view/certification/components'
import { toastController } from '@ionic/vue'
import { certificationApi, userApi, dictApi } from '@/apis'
import formData from '@/view/certification/formData'
import { actionSheetController } from '@ionic/vue'
import { useStore } from 'vuex'
import { loadingCreate } from '@/utils/alert'

export default {
  setup() {
    const store = new useStore()
    document.getElementsByTagName('title')[0].innerText = '认证完成'

    const route = new useRoute()
    const userType = route.query.userType || 'individual'
    const textDatas = {
      individual: {
        title: '个人认证',
        prompt: '请根据下方提示上传个人实名认证所需要的资料',
        IDCardTitles: ['1. 上传身份证图片', '2. 上传手持身份证人像面图片'],
      },
    }
    const idCardBackKey = 'idCardBack'
    const idCardPositiveKey = 'idCardPositive'
    const idCardUserKey = 'idCardUser'

    const idCardBackUrl = ref('')
    const idCardPositiveUrl = ref('')
    const idCardUserUrl = ref('')
    const textData = reactive(textDatas[userType])
    document.getElementsByTagName('title')[0].innerText = textData.title

    const keysData = formData[userType]
    const mData = keysData.reduce((o, item) => {
      return { ...o, [item.key]: '' }
    }, {})

    const nodes = keysData.reduce((o, item) => {
      return { ...o, [item.key]: ref(null) }
    }, {})

    const form = reactive(mData)

    const selects = reactive({
      userSex: [],
      nation: [],
    })

    const requiredErrorKey = ref('')

    const onBlur = () => {
      requiredErrorKey.value = ''
    }

    const presentActionSheet = async (key) => {
      const sheetSelect = selects[key].map((item) => {
        return {
          text: item.dictName,
          role: item.dictCode,
        }
      })
      const actionSheet = await actionSheetController.create({
        cssClass: 'my-custom-class',
        buttons: [
          ...sheetSelect,
          {
            text: '取消',
            role: 'cancel',
          },
        ],
      })
      await actionSheet.present()

      const { role } = await actionSheet.onDidDismiss()
      if (['cancel', 'backdrop'].includes(role)) {
        return
      }
      form[key] = role
    }

    const onDateChange = (key, value) => {
      // form[key] = value
      form[key] = dayjs(value).format('YYYY/MM/DD')
    }

    const imageFiles = reactive({
      idCardBack: '',
      idCardPositive: '',
      idCardUser: '',
    })

    const uploadToast = async (key) => {
      const errs = {
        idCardBack: '上传身份证人像面',
        idCardPositive: '上传身份证国徽面',
        idCardUser: '上传法定代表人手持身份证人像面',
      }
      const toast = await toastController.create({
        message: `请${errs[key]}`,
        position: 'top',
        translucent: true,
        duration: 3000,
      })
      return toast.present()
    }

    const onCaptured = (key, imageFile) => {
      imageFiles[key] = imageFile.imageKey
      imageFiles[`${key}FileId`] = imageFile.id
    }

    const verifyImages = () => {
      const IDCardImageKeys = ['idCardBack', 'idCardPositive', 'idCardUser']

      const errImageKey = IDCardImageKeys.find((key) => imageFiles[key] == '')
      if (errImageKey) {
        uploadToast(errImageKey)
        document.getElementById(errImageKey).scrollIntoView()
        return false
      }
      return true
    }

    const verifyBase = () => {
      const requiredKeys = keysData
        .filter(({ isRequired }) => isRequired)
        .map(({ key }) => key)
      const errKey = requiredKeys.find((key) => form[key] == '')
      console.log('onSubmit', errKey)
      if (errKey) {
        const key = errKey
        const node = nodes[`${key}`]
        console.log('node', nodes, errKey, key)
        node.value.focus()
        requiredErrorKey.value = key
        return false
      }
      return true
    }

    const onSubmit = async () => {
      console.log('onSubmit')

      if (!verifyBase()) {
        return
      }
      if (!verifyImages()) {
        return
      }
      const loading = await loadingCreate('资料提交中...')
      try {
        await certificationApi.individualInputData(form)
        const { id } = await certificationApi.individual(imageFiles)
        router.replace('/certification/fulfill')
      } catch (error) {
      } finally {
        loading.dismiss()
      }
    }

    const getData = async () => {
      const loading = await loadingCreate('数据获取中...')
      try {
        const dictData = await dictApi.base({
          dictTag: '性别|民族',
        })
        selects.userSex = dictData['性别']
        selects.nation = dictData['民族']
        const info = await userApi.individualInfo()
        const infoKeys = Object.keys(info)
        infoKeys.forEach((key) => {
          if (form.hasOwnProperty(key) || key == 'id') {
            form[key] = info[key]
          }
          if (imageFiles.hasOwnProperty(key)) {
            imageFiles[key] = info[key]
          }
        })

        idCardBackUrl.value = info.idCardBackUrl
        idCardPositiveUrl.value = info.idCardPositiveUrl
        idCardUserUrl.value = info.idCardUserUrl
      } catch (error) {
      } finally {
        loading.dismiss()
      }
    }

    onBeforeMount(async () => {
      getData()
    })

    return {
      textData,
      imageFiles,
      form,
      keysData,
      nodes,
      selects,
      requiredErrorKey,
      presentActionSheet,
      onBlur,
      onSubmit,
      onCaptured,
      onDateChange,
      userType,
      idCardBackKey,
      idCardPositiveKey,
      idCardUserKey,
      idCardBackUrl,
      idCardPositiveUrl,
      idCardUserUrl,
    }
  },
  components: { IDCard, Camera },
}
</script>

<style lang="scss">
@import 'style.scss';

.certification-uploadDocuments {
  .card {
    padding: 40px 75px 1px;
    background-color: #fff;
  }
  .toast-wrapper {
    --background: red;
    // --background: rgba(0,0,0, .7);
  }
  ion-content {
    --background: #f5f5f5;
  }

  .title {
    font-size: 32px;
    font-weight: bold;
    color: #333333;
  }
  .id-title {
    font-size: 32px;
    color: #333333;
  }
  .label {
    font-size: 28px;
    color: #666666;
  }
}
</style>